import { HttpHandler } from '../../api/HttpHandler';
import { notifyAboutJoinToTheVideoChat } from '../../api/notifications';
import { DateTime } from 'luxon';
import { environment } from '../../enviroments';
import { IntlShape } from 'react-intl';
import { decOfNum } from '@mindly/ui-components';

let consultationIDGlobal: string | null = null;
let consultationTimeGlobal: number | null = null;
let paymentTypeGlobal: string | undefined = undefined;
let userIdGlobal: string | null = null;
let psychologistIdGlobal: string | null = null;

let requestSenderIntervalID: number | undefined;

// TODO: This lines of code to strange
window.addEventListener('onConferenceJoined', async () => {
  if (consultationIDGlobal && consultationTimeGlobal) {
    requestSenderIntervalID = await listenerOnJoinTimeGap(
      consultationIDGlobal,
      consultationTimeGlobal,
      paymentTypeGlobal
    );
    if (userIdGlobal && psychologistIdGlobal) {
      await notifyAboutJoinToTheVideoChat(userIdGlobal, psychologistIdGlobal);
    }
  }
});

window.addEventListener('onConferenceLeft', async () => {
  listenerOnLeave(requestSenderIntervalID);
  console.log('Left from conference');
});

const refundMoney = async (consultationId: string): Promise<void> => {
  const requestURL = `${environment.STRIPE_PAYMENTS_APP_URL}/payment-intent/${consultationId}/client/refund`;

  await HttpHandler({
    method: 'POST',
    url: requestURL,
  });
};

const deleteConsultation = async (consultationID: string, userId: string) => {
  const requestURL = `${environment.BOOKING_URL}/cancelConsultation/${userId}/${consultationID}`;
  const body = { canceledBy: 'user' };

  const response = await HttpHandler({
    method: 'POST',
    url: requestURL,
    data: body,
  });

  return response.data;
};

export const cancelConsultationByID = async (
  consultationID: string,
  minimumPeriodForCancellationSeconds: number,
  consultationTime: number,
  intl: IntlShape,
  userId: string,
  subscriptionID?: string | null,
  paymentIntentId?: string | null
) => {
  const localTime = DateTime.now().toSeconds();
  if (consultationTime < localTime + minimumPeriodForCancellationSeconds) {
    const hours = Math.floor(minimumPeriodForCancellationSeconds / 60 / 60);
    const errorMessage =
      minimumPeriodForCancellationSeconds === 0
        ? intl.formatMessage({
            id: 'booking.cancel.consultation_was_started_error',
            defaultMessage: 'Консультацію не можливо відмінити якщо вона вже почалась',
          })
        : intl.formatMessage(
            {
              id: 'booking.cancel.consultation_started_soon_error',
              defaultMessage: `Консультацію можливо скасувати тільки за {hours} {hours_title} до її початку`,
            },
            {
              hours,
              hours_title: decOfNum(hours, [
                intl.formatMessage({
                  id: 'other.hour.one2',
                  defaultMessage: 'годину',
                }),
                intl.formatMessage({
                  id: 'other.hour.many',
                  defaultMessage: 'години',
                }),
                intl.formatMessage({
                  id: 'other.hour.several',
                  defaultMessage: 'годин',
                }),
              ]),
            }
          );

    throw new Error(errorMessage);
  }

  let data;
  if (subscriptionID) {
    data = await deleteConsultation(consultationID, userId);
  } else if (paymentIntentId) {
    data = await refundMoney(consultationID);
  } else {
    throw new Error('No payment intent or subscription id');
  }

  return data;
};

export const checkAbilityToCancelConsultation = (
  consultationTime: number,
  minimumPeriodForRescheduleSeconds: number
): boolean => {
  const localTime = DateTime.now().toSeconds();
  if (consultationTime < localTime + minimumPeriodForRescheduleSeconds) {
    return false;
  }
  return true;
};

export const listenerOnJoinTimeGap = async (
  consultationId: string,
  consultationTime: number,
  payment_type: string | undefined
): Promise<number | undefined> => {
  const sessionTimeInSeconds = DateTime.fromSeconds(consultationTime);
  const listenerStartTime = sessionTimeInSeconds
    .setZone('utc')
    .set({ minute: 0, second: 0, millisecond: 0 })
    .minus({ minutes: 30 });
  const listenerEndTime = sessionTimeInSeconds.set({ minute: 0, second: 0, millisecond: 0 }).plus({ minutes: 59 });
  const dateNow = DateTime.now().set({
    second: 0,
    millisecond: 0,
  });

  if (dateNow > listenerStartTime && dateNow < listenerEndTime && payment_type === 'paid_0') {
    const body = { session_status: 'client_showed' };

    const updateLogRequestURL = `${environment.CONSULTATION_URL}/free-consultation-log/${consultationId}`;
    await HttpHandler({
      method: 'PATCH',
      url: updateLogRequestURL,
      data: body,
    });

    let counter = 0;

    const requestSenderId = window.setInterval(
      async () => {
        counter++;
        await HttpHandler({
          method: 'PATCH',
          url: updateLogRequestURL,
          data: body,
        });
        if (counter === 3) {
          clearInterval(requestSenderId);
        }
      },
      3 * 60 * 1000
    );

    return requestSenderId;
  }
  return undefined;
};

export const listenerOnLeave = (intervalId: number | undefined): void => {
  if (intervalId) {
    clearInterval(intervalId);
  }
};
